<template>
  <div>
    <tour-guide :tour="tour" :is-expert="isExpert" :trip-id="tour.id" />
    <tour-travel-expert
      v-if="!isExpert"
      :expert-data="tour.expert_data"
      :tour-name="tour.name"
      :trip-id="tour.id"
    />
  </div>
</template>

<script>
import TourGuide from "./guide.vue";
import TourTravelExpert from "./expert.vue";

export default {
  components: {
    TourGuide,
    TourTravelExpert,
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isExpert() {
      return this.tour.tour_leader.is_head_expert;
    },
  },
};
</script>
